import chipotle1 from '../../../media/experience/chipotle/22785F29-D516-4289-A60F-E9D7216FDE85_1_105_c.jpeg';
import chipotle2 from '../../../media/experience/chipotle/53ECEF64-9E1C-4537-971F-9384D18A94EA_1_105_c.jpeg';
import chipotle3 from '../../../media/experience/chipotle/AB9C9AE4-DD04-484E-AF18-8E3B7C88B512_1_105_c.jpeg';
import chipotle4 from '../../../media/experience/chipotle/D4EC271D-9A93-484B-BF6F-C6880EB427CB_1_201_a.jpeg';
import chipotle5 from '../../../media/experience/chipotle/F93527C6-F1D4-43D6-8EE7-3C4C2FE9677B_1_105_c.jpeg';
import chipotle6 from '../../../media/experience/chipotle/364DBC23-8B5D-4263-A20F-70F1F8F48BAF_1_105_c.jpeg';
import chipotle7 from '../../../media/experience/chipotle/tiki_time.jpeg';
import chipotle8 from '../../../media/experience/chipotle/lunch.jpeg';
import chipotle9 from '../../../media/experience/chipotle/coding-lunch.jpeg';
import chipotlePoster from '../../../media/experience/chipotle/ChipotleIcon.png';

const chipotleData = {
  company: "Chipotle Mexican Grill",
  slug: "chipotle",
  posterTitle: "Chipotle",
  poster: chipotlePoster,
  location: "Newport Beach, CA",
  heroImage: chipotle3,

  roles: [
    {
      title: "Full Stack Engineer, Intern",
      start: "June 2025",
      end: "August 2025",
      summary: "At Chipotle's technology hub in Newport Beach, I contributed to production systems serving millions of customers nationwide. I developed full-stack features across multiple repositories, building backend APIs with C# .NET and Azure, frontend interfaces with Vue.js and TypeScript, and data layers with Cosmos DB. I also contributed backend APIs and TypeScript work for Pepper, Chipotle's internal AI chatbot, deployed on Azure through the same DevOps pipelines. I collaborated with engineering teams through Azure DevOps on code reviews, sprint planning, and CI/CD for enterprise applications.",
    },
  ],

  techStack: [
    "C#",
    ".NET Core",
    "Azure Cloud",
    "Vue.js",
    "TypeScript",
    "Cosmos DB",
    "Pepper AI chatbot",
    "Azure DevOps",
    "REST APIs",
    "CI/CD"
  ],

  gallery: [
    { type: 'image', src: chipotle1, alt: "Intern class photo at Chipotle's Innovation lab" },
    { type: 'image', src: chipotle2, alt: 'Intern class at Angel Stadium' },
    { type: 'image', src: chipotle3, alt: "Intern Class photo with Chris Brandt, Chipotle's CMO" },
    { type: 'image', src: chipotle6, alt: 'Photo with the 3 other software development interns' },
    { type: 'image', src: chipotle4, alt: 'First day intern class photo' },
    { type: 'image', src: chipotle5, alt: 'Working from home on internal website' },
    { type: 'image', src: chipotle7, alt: 'Polaroid with the 3 other software development interns at company party' },
    { type: 'image', src: chipotle8, alt: 'Team lunch with engineering team' },
    { type: 'image', src: chipotle9, alt: 'Coding while eating Chipotle' }
  ],

  links: {
    company: "https://www.chipotle.com",
    linkedin: "https://www.linkedin.com/company/chipotle-mexican-grill/"
  }
};

export default chipotleData;
